import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

const ignoredErrorCodes = new Set(['REQUEST_CANCELED']);

const GlobalApiErrorSnackbar = () => {
  const [state, setState] = useState({
    open: false,
    message: '',
    severity: 'error',
  });

  useEffect(() => {
    const onApiError = (event) => {
      const payload = event?.detail || {};
      if (ignoredErrorCodes.has(payload.code)) {
        return;
      }

      const severity = payload.status >= 500 ? 'error' : 'warning';
      setState({
        open: true,
        message: payload.message || 'Request failed.',
        severity,
      });
    };

    window.addEventListener('app:api-error', onApiError);
    return () => window.removeEventListener('app:api-error', onApiError);
  }, []);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setState((prev) => ({ ...prev, open: false }));
  };

  return (
    <Snackbar
      open={state.open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={state.severity} sx={{ width: '100%' }}>
        {state.message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalApiErrorSnackbar;
